<template>
  <div
    class="mb-5"
    :class="left ? 'text-left' : 'text-center'"
    data-aos="zoom-in"
    data-aos-easing="ease"
    data-aos-duration="500"
    data-aos-once="true"
  >
    <SmallText class="mb-2" v-if="legenda">{{ legenda }}</SmallText>
    <div class="pa-0 ma-0 elevation-0">
      <img :src="require(`../assets/${src}`)" class="rounded-lg" />
    </div>
    <SmallText v-if="fonte">Fonte: {{ fonte }}</SmallText>
  </div>
</template>

<script>
import SmallText from "@/components/SmallText.vue";

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    fonte: {
      type: String,
      required: false,
    },
    legenda: {
      type: String,
      required: false,
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    SmallText,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
img {
  width: 100%;
}
</style>
